import React from 'react';
import { Route, Switch } from 'react-router-dom';
import MainWrapper from '../MainWrapper';
import Landing from '../../Landing/index';
import NotFound404 from '../../DefaultPage/404/index';
import LockScreen from '../../Account/LockScreen/index';
import LogIn from '../../Account/LogIn/index';
import PrintData from '../../Account/PrintData/index';
import PrintBinData from '../../Account/PrintBinData/index';
import PrintPickingData from '../../Account/PrintPickingData/index';
import PrintPickingHulData from '../../Account/PrintPickingHulData/index';
import DRSReportDetail from '../../Account/DRSReportDetail/index';
import DRSCLDReportDetail from '../../Account/DRSCLDReportDetail/index';

import PrintInboundReceivingData from '../../Account/PrintInboundReceivingData/index';


import PrintPutawayDetail from '../../Account/PrintPutawayDetail/index';
import PrintPickingDetail from '../../Account/PrintPickingDetail/index';
import PrintPickingHulDetail from '../../Account/PrintPickingHulDetail/index';
import PrintPickingNPPHulDetail from '../../Account/PrintPickingNPPHulDetail/index';
import PrintPickingNPPHulAllDetail from '../../Account/PrintPickingNPPHulAllDetail/index';


import ViewMapData from '../../SecondaryUpload/ViewMap/index.jsx';


import LogInPhoto from '../../Account/log_in_photo/index';
import Register from '../../Account/Register/index';
import RegisterPhoto from '../../Account/RegisterPhoto/index';
import WrappedRoutes from './WrappedRoutes';
import ResetPassword from '../../Account/ResetPassword/index.jsx';
import LocationSelection from '../../Account/LocationSelection/index'
import PrivacyPolicy from '../../PrivacyPolicy.jsx';



const Router = () => (
  <MainWrapper>
    <main>
      <Switch>
        <Route exact path="/" component={LogIn} />
        <Route exact path="/password-reset" component={ResetPassword} />
         <Route exact path="/jarvis/privacy-policy" component={PrivacyPolicy} />
        <Route path="/location_selection" component={LocationSelection} />
        <Route path="/404" component={NotFound404} />
        <Route path="/lock_screen" component={LockScreen} />
        <Route path="/log_in" component={LogIn} />
        <Route path="/print_data" component={PrintData} />
		    <Route path="/print_bin_data" component={PrintBinData} />
        <Route path="/printPickigData" component={PrintPickingData} />
        <Route path="/printPickigHulData" component={PrintPickingHulData} />

        <Route path="/printPickigDetail" component={PrintPickingDetail} />
        <Route path="/drsReportDetail" component={DRSReportDetail} />
        <Route path="/drsCldReportDetail" component={DRSCLDReportDetail} />


        <Route path="/printPickigHulDetail" component={PrintPickingHulDetail} />
        <Route path="/printPickigNPPHulDetail" component={PrintPickingNPPHulDetail} />
        <Route path="/printPickigNPPHulAllDetail" component={PrintPickingNPPHulAllDetail} />



        <Route path="/printInboundReceivingData" component={PrintInboundReceivingData} />

        <Route path="/printPutawayDetail" component={PrintPutawayDetail} />
        <Route path="/log_in_photo" component={LogInPhoto} />
        <Route path="/register" component={Register} />
        <Route path="/view_map" component={ViewMapData} />
        <Route path="/register_photo" component={RegisterPhoto} />
        <Route path="/" component={WrappedRoutes} />
        
      </Switch>
    </main>
  </MainWrapper>
);

export default Router;
